import { createSlice } from '@reduxjs/toolkit';
import { FULLFILLED, LANGUAGE, PENDING, REJECTED } from '@constants/index';
import { AUTH_LOGIN } from '@root/store/action-types';

const INITIAL_STATE: IAuthFeature = {
  data: {
   rememberMe: false,
   language: LANGUAGE.KOREAN,
  },
  validationStates: {
    login: {
      isLoading: false,
      error: null,
    },
  },
};

export const authFeatureSlice = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    setRememberMe: (state, action) => {
      state.data.rememberMe = action.payload;
    },
    updateLanguage: (state, action) => {
      state.data.language = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(`${AUTH_LOGIN}${PENDING}`, (state) => {
      state.validationStates.login.isLoading = true;
    });
    builder.addCase(`${AUTH_LOGIN}${FULLFILLED}`, (state) => {
      state.validationStates.login.isLoading = false;
    });
    builder.addCase(`${AUTH_LOGIN}${REJECTED}`, (state) => {
      state.validationStates.login.isLoading = false;
    });
  },
});

export const authFeatureReducer = authFeatureSlice.reducer;
export const { setRememberMe, updateLanguage } = authFeatureSlice.actions;
